import { Injectable } from '@angular/core';
import { Url } from 'app/models2/commos/url';
import { FunctionsService } from 'brainloper-ui';
import { formatISO, parseISO, setHours, setMilliseconds, setMinutes, setSeconds } from 'date-fns';
import { Extension } from 'typescript';

@Injectable({
  providedIn: 'root'
})
export class UtilsServiceService {

  constructor(
    private functionsService: FunctionsService
  ) { }

  public getQueryParams(url: string): Url {
    let data = url.replace(/(.*)\?.*/, '$1');
    let queryParams = url.replace(/.*\?(.*)/, '$1');
    let arrQueryParams = queryParams.split('&');
    let objQueryParams = {};
    arrQueryParams.forEach((queryParam) => {
      let res = queryParam.split('=');
      objQueryParams[res[0]] = res[1];
    });
    return {
      url: data,
      params: objQueryParams,
    };
  }

  isValidDate(dateString: string): boolean {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      // No es una fecha válida
      return false;
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1; // getMonth() devuelve un índice basado en cero, por lo tanto +1
    const day = date.getDate();

    // Verifica si el año, el mes y el día son números válidos
    if (year.toString().length !== 4 || month < 1 || month > 12 || day < 1 || day > 31) {
      return false;
    }

    // Verificaciones adicionales para meses con menos de 31 días
    if ((month === 4 || month === 6 || month === 9 || month === 11) && day > 30) {
      return false;
    }

    // Verificación para febrero y años bisiestos
    if (month === 2) {
      const isLeapYear = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0));
      if (day > 29 || (!isLeapYear && day > 28)) {
        return false;
      }
    }

    // La fecha cumple con todas las validaciones
    return true;
  }

  formatDateTime(date: string, time: string): string {
    const parsedDate = new Date(date);
    // Extraer año, mes y día, y agregar ceros en caso necesario
    const year = parsedDate.getFullYear();
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0'); // Los meses comienzan desde 0, por lo que se suma 1
    const day = parsedDate.getDate().toString().padStart(2, '0');

    // Convertir la hora de formato de 12 horas a 24 horas
    let [timePart, period] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (period === 'PM' && hours !== 12) {
      hours += 12;
    } else if (period === 'AM' && hours === 12) {
      hours = 0;
    }

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    // Concatenar fecha y hora en el formato "YYYY-MM-DD HH:mm:ss"
    return `${year}-${month}-${day} ${formattedHours}:${formattedMinutes}:00`;
  }

  extractTime(isoString: string): string {
    const dateObj = new Date(isoString);

    // Extraer la hora y minutos
    let hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes().toString().padStart(2, '0');

    // Convertir la hora al formato de 12 horas
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convertir a formato de 12 horas (de 0 a 12)

    const formattedHours = hours.toString().padStart(2, '0');
    return `${formattedHours}:${minutes} ${period}`;
  }

  handlerDateToIsoString(date: string): string {
    // Parsear la fecha manualmente para evitar problemas de zona horaria
    let parsedDate = new Date(date);

    // Ajustar la hora a las 8:00 AM sin cambiar la fecha
    parsedDate.setUTCHours(8, 0, 0, 0);

    // Convertir la fecha ajustada de nuevo a formato ISO
    return formatISO(parsedDate, { representation: 'complete' });
}

}
